// Mock data for Executive EV

export const services = [
  {
    id: 1,
    title: "Airport Transfers",
    description: "Seamless luxury EV transfers to and from all major airports. Flight tracking and complimentary wait time included.",
    icon: "plane"
  },
  {
    id: 2,
    title: "Hourly Service",
    description: "Book our executive EVs by the hour for meetings, events, or a full day of professional transportation.",
    icon: "clock"
  },
  {
    id: 3,
    title: "City-to-City",
    description: "Long-distance luxury EV travel with professional chauffeurs. Stress-free journeys between cities.",
    icon: "map"
  },
  {
    id: 4,
    title: "Corporate Travel",
    description: "Dedicated executive transportation for business professionals. Reliable, discreet, and professional service.",
    icon: "briefcase"
  },
  {
    id: 5,
    title: "Special Events",
    description: "Arrive in style at weddings, galas, and exclusive events. Make every moment unforgettable.",
    icon: "star"
  },
  {
    id: 6,
    title: "Private Aviation",
    description: "Specialized service for private jet terminals and FBOs. Coordinated, discreet, and timely.",
    icon: "plane-takeoff"
  }
];

export const fleet = [
  {
    id: 1,
    name: "Tesla Model S Plaid",
    category: "Executive Sedan",
    passengers: 4,
    luggage: 3,
    image: "https://images.unsplash.com/photo-1560958089-b8a1929cea89",
    features: ["Zero Emissions", "Premium Interior", "Advanced Tech"]
  },
  {
    id: 2,
    name: "Mercedes EQS",
    category: "Luxury Sedan",
    passengers: 4,
    luggage: 3,
    image: "https://images.unsplash.com/photo-1617704548623-340376564e68",
    features: ["HEPA Filtration", "Massage Seats", "Whisper Quiet"]
  },
  {
    id: 3,
    name: "BMW i7",
    category: "Premium Executive",
    passengers: 4,
    luggage: 4,
    image: "https://images.unsplash.com/photo-1623572435912-9940866dca4e",
    features: ["Executive Lounge", "Theater Screen", "Skylounge Roof"]
  },
  {
    id: 4,
    name: "Porsche Taycan",
    category: "Sport Sedan",
    passengers: 4,
    luggage: 2,
    image: "https://images.unsplash.com/photo-1666919643134-d97687c1826c",
    features: ["Sport Performance", "Premium Audio", "Carbon Neutral"]
  },
  {
    id: 5,
    name: "Audi e-tron GT",
    category: "Grand Tourer",
    passengers: 4,
    luggage: 3,
    image: "https://images.unsplash.com/photo-1561580125-028ee3bd62eb",
    features: ["quattro AWD", "Bang & Olufsen", "Matrix LED"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Sterling",
    role: "CEO, Sterling Ventures",
    content: "Executive EV has redefined luxury transportation. Professional, punctual, and environmentally conscious. Perfect for our executive team.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "VP of Operations",
    content: "The seamless booking experience and exceptional service quality make Executive EV our go-to for all corporate travel needs.",
    rating: 5
  },
  {
    id: 3,
    name: "David Montgomery",
    role: "Private Client",
    content: "From airport transfers to special events, Executive EV consistently delivers world-class service. The EV fleet is impressive.",
    rating: 5
  }
];

export const features = [
  {
    id: 1,
    title: "100% Electric Fleet",
    description: "Experience luxury without compromise. Our entire fleet consists of premium electric vehicles.",
    icon: "zap"
  },
  {
    id: 2,
    title: "Professional Chauffeurs",
    description: "Highly trained, vetted, and experienced professionals dedicated to your safety and comfort.",
    icon: "shield-check"
  },
  {
    id: 3,
    title: "24/7 Availability",
    description: "Round-the-clock service to meet your schedule. Book anytime, travel anywhere.",
    icon: "clock"
  },
  {
    id: 4,
    title: "Flight Tracking",
    description: "Real-time flight monitoring ensures your chauffeur is always there when you land.",
    icon: "plane"
  },
  {
    id: 5,
    title: "Carbon Neutral",
    description: "All rides are carbon neutral. Travel responsibly while enjoying ultimate luxury.",
    icon: "leaf"
  },
  {
    id: 6,
    title: "Fixed Pricing",
    description: "Transparent, upfront pricing with no surge charges. Know your cost before you book.",
    icon: "dollar-sign"
  }
];